export default __webpack_public_path__ + "static/media/team-photo-2018.09765aaf.jpg";